import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'badge',
    templateUrl: './badge.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BadgeComponent implements OnInit {
  @Input() value?: any;
  @Input() overlap?: boolean;
  @Input() color?: string;
  @Input() position?: string;
  constructor() {}

  ngOnInit() {}
}
